import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment-timezone';
import { Box } from '@mui/material';
import useIsMobile from '../../../../../hooks/useIsMobile';
import { RecurringItemFields } from '../../../../../custom-components/schedule2/Dialogs/MilkSupplyItemDialog';

const ScheduleRecurringItems = ({ name, props }) => {
    const { control, watch } = useFormContext();
    const isMobile = useIsMobile();
    const { startDateField } = props;
    const item = watch('recur_metadata');
    const startDate = watch(startDateField);
    const defaultEndDate = startDate ? moment(startDate) : moment();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <Box sx={{ border: (th) => `1px solid ${th.palette.divider}`, borderRadius: isMobile ? 0 : '4px', padding: isMobile ? 0 : 2 }}>
                    <RecurringItemFields
                        item={
                            value ??
                            item ?? {
                                frequency: 1,
                                unit: 'day',
                                recurEndDate: defaultEndDate,
                                days: [moment().day()],
                            }
                        }
                        setItem={(val) => onChange(val)}
                        // wrap
                    />
                </Box>
            )}
        />
    );
};

export default ScheduleRecurringItems;
